import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Enhances a <select> into a searchable dropdown over the <option>s the server
// rendered. Defaults suit the multi-value class fields: create: true lets an
// editor add a value that isn't listed, and the remove_button plugin shows the
// tag clear. Pass create: false and maxItems: 1 (e.g. the genus picker) for a
// single-select that only accepts an existing option.
export default class extends Controller {
  static values = {
    create: { type: Boolean, default: true },
    maxItems: Number,
  }

  connect() {
    const single = this.hasMaxItemsValue && this.maxItemsValue === 1
    this.select = new TomSelect(this.element, {
      create: this.createValue,
      maxItems: this.hasMaxItemsValue ? this.maxItemsValue : null,
      persist: false,
      plugins: single ? [] : ["remove_button"],
    })
  }

  disconnect() {
    if (!this.select) return

    // destroy() puts back the <option>s the page loaded with. Re-apply the
    // current picks, so a picker that is only being moved (e.g. inside the
    // turbo-permanent monograph form) keeps its unsaved selection when it
    // reconnects. Picks go last, in pick order, because TomSelect reads
    // selected options in DOM order and the classes "chain in order". A
    // cleared single-select reports "", which isn't a pick: skip it rather
    // than invent a blank option.
    const values = [this.select.getValue()].flat().filter((v) => v !== "")
    this.select.destroy()
    for (const option of this.element.options) option.selected = false
    for (const value of values) {
      const option = [...this.element.options].find((o) => o.value === value) ??
        new Option(value, value)
      this.element.append(option)
      option.selected = true
    }
  }
}
